const roundToPercent = (n) => {
	if (!Number.isFinite(n)) return '—';
	return (n * 100).toFixed(2).replace('.', ',') + ' %';
};

export const getQuizTestReportTableRows = (data) => {
	const rows = data.map((d, i) => (
		<tr key={i}>
			<td>{d['no']}</td>
			<td>{d['version']}</td>
			<td>{d['compare_source']}</td>
			<td>{d['compare_to']}</td>
			<td>{roundToPercent(d['compare_to'] / d['compare_source'])}</td>
		</tr>
	));

	return rows;
};
